export { default } from './internal/simple';
export type { SimpleTagProps } from './internal/shared/types';
